// src/components/LightingAspects.jsx

import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom'; // --- 1. Import Link ---
import './LightingAspects.css';

// --- Image Imports ---
import technicalImage from '../Images/Light1.jpg';
import decorativeImage from '../Images/Light2.jpg';

const lightingData = [
  {
    title: 'Technical Lighting',
    description: 'Precision-engineered for function and performance. Technical lighting focuses on providing optimal illumination for specific tasks, enhancing architecture, and ensuring safety with unmatched clarity.',
    image: technicalImage,
  },
  {
    title: 'Decorative Lighting',
    description: 'Artfully crafted to create atmosphere and inspire emotion. Decorative lighting acts as a visual centerpiece, defining the style of a space and turning illumination into an experience.',
    image: decorativeImage,
  }
];

const LightingAspects = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    const cards = sectionRef.current.querySelectorAll('.aspect-card');
    cards.forEach(card => observer.observe(card));

    return () => {
      cards.forEach(card => {
        if (card) { // Add a check to ensure card exists before unobserving
          observer.unobserve(card);
        }
      });
    };
  }, []);

  return (
    <section className="lighting-aspects-container" ref={sectionRef}>
      <h2 className="aspects-section-title">
        A Spectrum of <span>Light</span>
      </h2>
      <div className="lighting-aspects-grid">
        {lightingData.map((item, index) => (
          <div key={index} className="aspect-card">
            <div className="aspect-image" style={{ backgroundImage: `url(${item.image})` }}></div>
            <div className="aspect-content">
              <div className="text-wrapper">
                <h3 className="aspect-title">{item.title}</h3>
                <p className="aspect-description">{item.description}</p>
                {/* --- 2. Replace <a> with Link --- */}
                <Link to="/products" className="aspect-cta">Learn More</Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LightingAspects;